import React, { Component } from "react";
import ReactDOM from "react-dom";
import Grid from "@material-ui/core/Grid";

// import './Featurescards.css'
// images
import logoimg from "../../img/logo.png";
import { useState } from "react";
import axios from "axios";

class Quiz extends React.Component {
  constructor(props) {
    super(props);

    var dataSet = [
      {
        question: "What is your name?",
        answers: ["Next"],
        correct: 1,
      },
      {
        question: "Do you follow our twitter page @PCATV2?",
        answers: ["Next"],
        correct: 3,
      },
      {
        question: "Enter your twitter username:",
        answers: ["Next"],
        correct: 3,
      },
      {
        question: "Do you follow us on telegram @PCATV2group?",
        answers: ["Next"],
        correct: 2,
      },
      {
        question: "Enter your telegram username:",
        answers: ["Next"],
        correct: 0,
      },
      {
        question:
          "Enter your wallet address where you hold a minimum of 0.3 banana:",
        answers: ["Next"],
        correct: 3,
      },

      {
        question: "Enter the slot that you would like to select for presale:",
        answers: ["Next"],
        correct: 0,
      },
      {
        question:
          "Upload screenshots of 5 groups where you have shilled PCATV2",
        answers: ["Finish"],
        correct: 0,
      },
    ];

    this.state = {
      current: 0,
      dataSet: dataSet,
      correct: 0,
      incorrect: 0,
    };
    this.handleClick = this.handleClick.bind(this);
  } // end constructor

  handleClick(choice) {
    if (choice == this.state.dataSet[this.state.current].correct) {
      this.setState({ correct: this.state.correct + 1 });
    } else {
      this.setState({ incorrect: this.state.incorrect + 1 });
    }

    if (this.state.current == 8) {
      this.setState({ current: 0 });
      this.setState({ incorrect: 0 });
      this.setState({ correct: 0 });
    } else {
      this.setState({ current: this.state.current + 1 });
    }
  }

  render() {
    return (
      <div>
        <ScoreArea
          correct={this.state.correct}
          incorrect={this.state.incorrect}
          error={this.props.error}
          setError={this.props.setError}
          errorMsg={this.props.errorMsg}
          setErrorMsg={this.props.setErrorMsg}
        />
        <QuizArea
          files={this.props.files}
          setFiles={this.props.setFiles}
          qCounter={this.props.qCounter}
          setQCounter={this.props.setQCounter}
          setname={this.props.setname}
          name={this.props.name}
          data={this.props.data}
          setdata={this.props.setdata}
          setSuccess={this.props.setSuccess}
          handleClick={this.handleClick}
          error={this.props.error}
          setError={this.props.setError}
          setLoading={this.props.setLoading}
          errorMsg={this.props.errorMsg}
          setErrorMsg={this.props.setErrorMsg}
          dataSet={this.state.dataSet[this.state.current]}
        />
      </div>
    );
  }
}

function Question(props) {
  const handleChange = (event) => {
    console.log("Setting files");
    props.setFiles(event.target.files);
    console.log(props.files.length);
  };

  const uploadFiles = () => {};

  var style = {
    color: "black",
    fontSize: "20px",
    textAlign: "left",
  };
  return (
    <div>
      <h1 style={style}>
        {props.dataSet.question}
        <span style={{ color: "red" }}> *</span>
      </h1>

      {(() => {
        if (props.qCounter === 7) {
          return (
            <div className="App">
              <input
                type="file"
                id="file"
                multiple
                name="file"
                onChange={handleChange}
              />
            </div>
          );
        }
      })()}
    </div>
  );
}

function Answer(props) {
  var style = {
    // height: 50,
    position: "absolute",
    marginTop: "61px",
    // width: "20%",
    marginLeft: "-2.7em",
    fontSize: "15px",
    padding: "11px 10px",
    borderRadius: "5px",
    // width: "20%",
    backgroundColor: "#4043ff",
    border: "0px",
    color: "#fff",
  };

  const submitForm = () => {
    const formData = new FormData();
    const formMapping = {
      0: "name",
      1: "twitterFollow",
      2: "twitterUsername",
      3: "telegramFollow",
      4: "telegramUsername",
      5: "walletAddress",
      6: "slot",
    };

    console.log("Creating form data");
    console.log(props.data);
    for (let i = 0; i < props.data.length; i++) {
      formData.append(formMapping[i], props.data[i]);
    }

    for (let i = 0; i < props.files.length; i++) {
      formData.append(`files[${i}]`, props.files[i]);
    }
    console.log("sending request");
    props.setLoading(true);
    axios
      .post("https://api.pcatv2.finance/presale", formData)
      .then((res) => {
        props.setSuccess(true);
        props.setLoading(false);
      })
      .catch((res) => {
        props.setLoading(false);
        if (res.response) {
          alert(res.response.data.err);
        }
      });
    console.log(formData);
  };
  return (
    <div className="text-right">
      {/* props.setname(""); */}
      <button
        style={style}
        onClick={() => {
          if (props.qCounter === 7) {
            if (props.files.length !== 5) {
              props.setError(true);
              props.setErrorMsg("Upload 5 files please");
              return;
            }
            submitForm();
            return;
          }
          if (!props.name) {
            props.setError(true);
            props.setErrorMsg(
              props.qCounter === 1 ||
                props.qCounter === 3 ||
                props.qCounter === 6
                ? "Please Select an Option"
                : "This Field is Required"
            );
            return;
          }
          if (props.qCounter === 0 && !props.name.match(/^([^0-9]*)$/)) {
            props.setError(true);
            props.setErrorMsg("No numbers allowed in name.");
            return;
          }
          if (props.qCounter === 5) {
            props.setLoading(true);
            axios
              .get(
                "https://api.pcatv2.finance/checkwallet?walletAddress=" +
                  props.name
              )
              .then((res) => {
                props.setError(false);
                props.setErrorMsg(null);
                props.setdata([...props.data, props.name]);
                props.setname("");

                props.handleClick(props.choice);

                props.setQCounter((c) => c + 1);
                props.setLoading(false);
                console.log(props.data);
              })
              .catch((res) => {
                if (res.response) {
                  console.log(res.response);
                  props.setLoading(false);
                  props.setError(true);
                  props.setErrorMsg(res.response.data);
                }
                return;
              });
          } else {
            props.setError(false);
            props.setErrorMsg(null);
            props.setdata([...props.data, props.name]);
            props.setname("");

            props.handleClick(props.choice);
            if (props.qCounter === 5) {
              submitForm();
            }
            // props.setQCounter((c) => c + 1);
            console.log(props.data);

            props.setQCounter((c) => c + 1);
            console.log(props.data);
          }
        }}
      >
        {props.answer}
      </button>
    </div>
  );
}

function InputAnsewer(props) {
  var style = {
    height: 50,
    position: "absolute",
    marginTop: "61px",
    width: "20%",
    marginLeft: "-228px",
    fontSize: "15px",
    padding: "11px 10px",
    borderRadius: "5px",
    width: "20%",
    backgroundColor: "#4043ff",
    border: "0px",
    color: "#fff",
  };
  return (
    <div className="">
      <input style={style} onClick={() => props.handleClick(props.choice)}>
        {props.input}
      </input>
    </div>
  );
}

function AnswerList(props) {
  var answers = [];
  for (let i = 0; i < props.dataSet.answers.length; i++) {
    answers.push(
      <Answer
        setFiles={props.setFiles}
        files={props.files}
        setQCounter={props.setQCounter}
        qCounter={props.qCounter}
        setdata={props.setdata}
        name={props.name}
        data={props.data}
        setname={props.setname}
        setSuccess={props.setSuccess}
        setLoading={props.setLoading}
        choice={i}
        error={props.error}
        setError={props.setError}
        errorMsg={props.errorMsg}
        setErrorMsg={props.setErrorMsg}
        handleClick={props.handleClick}
        answer={props.dataSet.answers[i]}
      />
    );
  }
  return <div class="sdfdsf" style={{position: "relative"}}>{answers}</div>;
}

function QuizArea(props) {
  var style = {
    width: "100%",
    display: "block",
    textAlign: "center",
    boxSizing: "border-box",
    float: "left",
    // padding: "0 2em"
  };
  return (
    <div style={style}>
      <Question
        files={props.files}
        setFiles={props.setFiles}
        dataSet={props.dataSet}
        qCounter={props.qCounter}
      />
      <AnswerList
        files={props.files}
        setFiles={props.setFiles}
        qCounter={props.qCounter}
        setQCounter={props.setQCounter}
        setname={props.setname}
        name={props.name}
        data={props.data}
        setdata={props.setdata}
        setSuccess={props.setSuccess}
        setLoading={props.setLoading}
        dataSet={props.dataSet}
        error={props.error}
        setError={props.setError}
        errorMsg={props.errorMsg}
        setErrorMsg={props.setErrorMsg}
        handleClick={props.handleClick}
      />
    </div>
  );
}

function TotalCorrect(props) {
  var style = {
    display: "inline-block",
    padding: "1em",
    background: "#eee",
    margin: "0 1em 0 0",
  };
  return <h2 style={style}>Correct: {props.correct}</h2>;
}

function TotalIncorrect(props) {
  var style = {
    display: "inline-block",
    padding: "1em",
    background: "#eee",
    margin: "0 0 0 1em",
  };
  return <h2 style={style}>Incorrect: {props.incorrect}</h2>;
}

function ScoreArea(props) {
  return <div>{}</div>;
}

// ReactDOM.render(
//   <Quiz />,
//   document.getElementById("root")
// )
export default Quiz;
